jQuery(function ($) {

  $('.block-module-news-carousel').each(function () {

    const $block     = $(this);
    const $swiperEl  = $block.find('.mySwiper');
    const $prev      = $block.find('.news-carousel__prev');
    const $next      = $block.find('.news-carousel__next');

    if (!$swiperEl.length) return;

    const autoplay = $swiperEl.data('autoplay') === true;
    const speed    = parseInt($swiperEl.data('speed'), 10) || 3500;

    const swiper = new Swiper($swiperEl[0], {
      effect: 'coverflow',

      // ✅ no overlap into the left column
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,

      allowTouchMove: window.innerWidth <= 768,

      autoplay: autoplay ? {
        delay: speed,
        disableOnInteraction: false
      } : false,

      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 80,
        modifier: 1,
        slideShadows: false
      }
    });

    // ✅ arrows (previous / next)
    $prev.on('click', () => swiper.slidePrev());
    $next.on('click', () => swiper.slideNext());

    // Update touch behaviour on resize
    $(window).on('resize', () => {
      swiper.allowTouchMove = window.innerWidth <= 768;
    });

  });

});
